import('bootstrap');

// TEST: ! Trigger Host build

// NOTE: This is fix for "All files must be modules when the '--isolatedModules' flag is provided." error.
export {};
